import { State } from 'redux/type'
import { IVendorInfoState, IVendorInfoErrors } from './types'
import { moduleName } from './constants'
import { VendorDetails } from '../../../features/MyCommunity/Vendors/VendorCreation/types'

const getVendorInfoState = (state: State): IVendorInfoState => state[moduleName]

export const getVendorInfo = (state: State): VendorDetails => {
  const vendorInfoState = getVendorInfoState(state)
  return vendorInfoState.vendorInfo
}
export const getError = (state: State): IVendorInfoErrors | null => {
  const vendorInfoState = getVendorInfoState(state)
  return vendorInfoState.error
}
